import postFormTo from "./post-form";

export default function cellarVisit() {
    var t_o_id;
    var telephone_inited = 0;
    // A.Scapin: funzione che inizializza il form "Visita la Cantina"
    window.initialize_gpa = function (validator_url, post_page_url, voucherstring) {
        /*
        DISABLE ADDRESS AUTOCOMPLETE!! REMOVED plugins/autocomplete-google-address*/
        //address_components types = ..
        var componentAddress = {
            street_number: 'short_name',  // numero
            route: 'long_name', // Indirizzo
            locality: 'long_name', // Citta o frazione
            administrative_area_level_3: 'short_name', // Citta
            administrative_area_level_2: 'short_name', // Provincia
            country: 'short_name', // Nazione
            postal_code: 'short_name' // cap
        };
        // add form component to retrieve the first one is google name the second one is form's field name
        var componentForm = {
            route: 'Indirizzo',
            locality: 'Citta',
            administrative_area_level_3: 'Citta',
            administrative_area_level_2: 'Provincia',
            country: 'Nazione',
            lat: 'latitudine',
            lng: 'longitudine'
        };

        var notAddress = false;

        var acInput = document.getElementById("address_geo_autocomplete");
        if (acInput && typeof google === 'object' && typeof google.maps === 'object') {
            window.autocomplete = new google.maps.places.Autocomplete(acInput);
            window.autocomplete.inputId = acInput.id;

            google.maps.event.addListener(window.autocomplete, 'place_changed', function () {
                // Get the place details from the autocomplete object.
                var place = window.autocomplete.getPlace();
                for (var component in componentForm) {
                    if (document.getElementById(componentForm[component]) != null) {
                        document.getElementById(componentForm[component]).value = '';
                        document.getElementById(componentForm[component]).disabled = false;
                    }
                }

                // Get each component of the address from the place details,
                // and then fill-in the corresponding field on the form.
                if (place.address_components !== undefined) {
                    for (var i = 0; i < place.address_components.length; i++) {
                        var addressType = place.address_components[i].types[0];
                        if (componentAddress[addressType]) {
                            var val = place.address_components[i][componentAddress[addressType]];
                            if (componentForm[addressType] != null && typeof document.getElementById(componentForm[addressType]) !== 'undefined') {
                                // complete address exception
                                if (addressType === 'route') {
                                    // try to retrieve street_number and postal_code too
                                    var street_number = '';
                                    var postal_code = '';
                                    for (var y = 0; y < place.address_components.length; y++) {
                                        var yType = place.address_components[y].types[0];
                                        switch (yType) {
                                            case 'street_number':
                                                street_number = ' ' + place.address_components[y][componentAddress[yType]];
                                                break;
                                            case 'postal_code':
                                                var mycap = place.address_components[y][componentAddress[yType]];
                                                document.getElementById('CAP').value = mycap;
                                                postal_code = ', ' + mycap;
                                                break;
                                            default:
                                                break;
                                        }
                                    }
                                    val = val + street_number + postal_code;
                                }

                                if (document.getElementById(componentForm[addressType]).value.length <= 0)
                                    document.getElementById(componentForm[addressType]).value = val;
                            }
                        }
                    }
                }

                // Retrieve latitude and/or longitude
                if (document.getElementById(componentForm.lat) != null) {
                    if (place.geometry.location != undefined) {
                        document.getElementById(componentForm.lat).value = place.geometry.location.lat();
                    }
                }
                if (document.getElementById(componentForm.lng) != null) {
                    if (place.geometry.location != undefined) {
                        document.getElementById(componentForm.lng).value = place.geometry.location.lng();
                    }
                }

                $(acInput).blur(); //faccio scattare la validazione sul campo

            });

            $(acInput).keydown(function (e) {
                if (e.keyCode != 13) {
                    for (var component in componentForm) {
                        if (document.getElementById(componentForm[component]) != null) {
                            document.getElementById(componentForm[component]).value = '';
                            document.getElementById(componentForm[component]).disabled = false;
                        }
                    }
                }
            });
        } else {
            notAddress = true;
        }


        var open_date_voucher = document.getElementById("open_date_voucher");
        if (open_date_voucher) {
            $(open_date_voucher).click(function (event) {
                if ($('#open_date_voucher')[0].checked) {
                    window.saveTheDate = $('#DataVisita').val();
                    $('#DataVisita').val(voucherstring);
                    $('#DataVisita').attr('disabled', 'disabled');
                    $('#DataVisita').attr('value', null);
                    $('#DataVisita').removeAttr('required');
                } else {
                    $('#DataVisita').removeAttr('disabled');
                    $('#DataVisita').val(window.saveTheDate);
                    $('#DataVisita').attr('value',window.saveTheDate);
                    $('#DataVisita').attr('required', '');
                }
            })
        }

        //VIP: gestione campo Telefono del form visita la cantina
        if (!telephone_inited) {
            const phoneInputField = document.querySelector("#Telefono");
            const phoneInput = intlTelInput(phoneInputField, {
                preferredCountries: ["it", "us", "gb", "fr", "de", "es", "at"],
                initialCountry: "it",
                geoIpLookup: window.getIp,
                utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
            });

            if (phoneInput !== undefined) {
                console.log('**************** 3 Telephone initialized ************+');
                telephone_inited = 1;
                $("#Telefono").on("blur", function () {
                    $(this).val(phoneInput.getNumber());
                    // valorizzare solo se non l'ho già preso dall'indirizzo
                    if (!$("#Nazione").val()) $("#Nazione").val(phoneInput.s.iso2.toUpperCase());//ISO code
                    $("#PhonePrefix").val(phoneInput.s.dialCode);
                });
            } else {
                console.log('**************** 4 Telephone NOT initialized, valori fissi ************+');
                telephone_inited = -1;//means error, plugin not loaded!
                // valorizzare solo se non l'ho già preso dall'indirizzo
                if (!$("#Nazione").val()) $("#Nazione").val('IT');//ISO code fisso
                $("#PhonePrefix").val('39');//fisso
            }

        } else console.log('**************** 5 Telephone not found! ************+');

        //VIP: FORM SUBMIT DEL VISITA LA CANTINA
        $('#visit-form').submit(function (event) {
            event.preventDefault();

            $('.page-loader').addClass('show'); // mostra loader

            clearTimeout(t_o_id);

            // rimuove tutte le indicazioni di errore
            $('.thom-form__error').html('');
            $('#visit-form').find('.field-error').removeClass("field-error");

            // campi obbligatori e spunte privacy: validazione nativa del browser (attributo required)
            var isOkToGo = true;

            function waitForCAP() {
                window.n_cap_attempts++;
                if (($('#CAP').val().length !== 0) || (window.n_cap_attempts === 5) || notAddress) {
                    if (isOkToGo) {
                        var $form = $('#visit-form');

                        // Definiamo la funzione di invio AJAX per non ripeterla
                        var proceedToAjax = function() {
                            $('.page-loader').addClass('show');
                            $.ajax({
                                type: 'POST',
                                url: validator_url,
                                data: $form.serialize(),
                                success: function (response) {
                                    if (!response.status) {
                                        $('.page-loader').removeClass('show');
                                        $form.find('button[type="submit"]').prop('disabled', false);
                                        $('.thom-form__error').html(response.message).fadeIn();
                                        $('#' + response.field).addClass('field-error');
                                        return false;
                                    }
                                    // All OK go!
                                    // prima: $.redirect(url, $form.serialize()) inviava un campo per carattere (vuole un oggetto, non una stringa)
                                    postFormTo(post_page_url, $form[0]);
                                },
                                error: function() {
                                    $('.page-loader').removeClass('show');
                                    $form.find('button[type="submit"]').prop('disabled', false);
                                }
                            });
                        };

                        // Il captcha è sempre obbligatorio: il token viene verificato lato server
                        window.executeRecaptchaProcess($form[0], function(token) {
                            proceedToAjax();
                        });
                    }
                } else {
                    // fa scattare forzatamente l'evento di aggiornamento
                    window.autocomplete.getPlace();
                    t_o_id = window.setTimeout(waitForCAP, 500);
                }
            }

            window.n_cap_attempts = 0;
            waitForCAP();
        });

        if (typeof window.sectionConditions !== "undefined") {
            window.sectionConditions.forEach(function (_sc) {
                //init sectionCondition on script load
                window.sectionCondition(_sc["sectionId"], _sc["visibleValue"], _sc["controlId"]);
            });
        }

    }

    window.sectionCondition = function (sectionId, visibleValue, controlId = null) {
        let $section = jQuery(sectionId);
        let $select = controlId ? jQuery(controlId) : jQuery(event.target);
        if ($section.length) {
            if ($select.val() === visibleValue) {
                $section.fadeIn();
            } else {
                $section.fadeOut();
            }
        }
    }

}